import { Chip, makeStyles } from '@material-ui/core';

export type OwnerRole = 'contact' | 'member';

type Props = {
  role: OwnerRole;
};

const useStyles = makeStyles((theme) => ({
  chip: ({ role }: Props) => ({
    backgroundColor: role === 'contact' ? theme.palette.admin.primary.main : '#e0e0e0',
    color: role === 'contact' ? theme.palette.admin.primary.contrastText : '#424242',
    fontWeight: 600,
    minWidth: 72,
  }),
}));

export function OwnerRoleChip({ role }: Props) {
  const classes = useStyles({ role });
  return <Chip size="small" className={classes.chip} label={role === 'contact' ? 'Contact' : 'Membre'} />;
}
